import { find } from 'controller/search/find'
import { findCities } from 'controller/search/findCities'

export const SearchController = {
  find,
  findCities,
}
